<template>
  <div v-if="loading" class="text-center">
    <span class="icon is-large">
      <font-awesome-icon class="fa-2x" icon="spinner" pulse />
    </span>
  </div>
</template>

<script>
export default {
  name: "LoadingIndicator",
  props: ["loading"]
};
</script>
